<div id="search" class="search">
    <div class="search-box White">
        <label class="title" for="search-desktop">SEARCH PURDUE GLOBAL</label>
        <form autocomplete="off" #form="ngForm" (ngSubmit)="onSubmit()" class="search-form">
            <div class="search-form-container">
                <input type="search" [(ngModel)]="searchText" name="queryString" required class="search-input" id="search-input" placeholder="What can we help you find?"  />
                <button type="submit" tabindex='0' class="btn primary-button search-btn text-center" aria-label="Search"><i class='far fa-search'></i></button>
            </div>
        </form>
    </div>
    @if(searchItems) {
        <div class="common-searched Steel" >
            <p class="header-p">Most Commonly Searched:</p>
            <ul class="terms align-justify">
                @for (item of searchItems; track $index) {
                    <li>
                        <a class="btn primary-button small" [routerLink]="['/search-results/']" [queryParams]="{q: item.trim()}" (click)="closeSearch.emit()">
                            {{ item }}
                        </a>
                    </li>
                }
            </ul>
        </div>
    }
   
</div>
